import { Countries } from "@features/seo/seo.constants";
import { City } from "@shared/lib/interfaces/city.interface";
import { RouterConfig } from "@shared/lib/routerConfig";
import { RouterSlugs } from "@shared/lib/routerSlugs";
import { COUNTRY_MAP } from "./constants";

export const generateCatalogUri = (
    countryCode?: Countries,
    cities?: City[],
    brand?: string,
    model?: string,
    generationCode?: number,
    restyling?: number,
    filters?: {
        bodyType?: string;
        priceFrom?: number;
        priceTo?: number;
    }
) => {
    let uri = RouterConfig.CATALOG;

    if (countryCode) {
        const countrySlug = Object.entries(COUNTRY_MAP).find(
            ([, code]) => code === countryCode
        )?.[0];

        if (countrySlug) {
            uri += `/${countrySlug}`;
        }
    }

    const city = cities && cities.length > 0 ? cities[0] : null;

    uri += city ? `/${city.alias}` : `/${RouterSlugs.SLUG_ALL_CITIES}`;
    uri += brand ? `/${brand}` : "";
    uri += model ? `/${model}` : "";
    uri += generationCode ? `/generation-${generationCode}` : "";
    if (generationCode) {
        uri += `/restyling-${restyling ?? 0}`;
    }

    uri += `/${RouterSlugs.SLUG_FILTERS_END}`;

    const queryParams: Record<string, string> = {};

    if (filters?.bodyType) queryParams.body_type = filters.bodyType;
    if (filters?.priceFrom) queryParams.price_from = filters.priceFrom.toString();
    if (filters?.priceTo) queryParams.price_to = filters.priceTo.toString();

    const queryString = new URLSearchParams(queryParams).toString();
    if (queryString) {
        uri += `?${queryString}`;
    }

    return uri;
};